import { useEffect, useState } from 'react';
import '../App.css';
import logo from '../assets/logo-black.png';
import logoOs from '../assets/logo-black-Os.png';
import logoFlock from '../assets/logo-black-Flock.png';
import logoBoh from '../assets/logo-black-boh.png';
import logoUtz from '../assets/logo-black-utz.png';

const testimonials = [
  {
    quote: 'I bike to work and have not had my bike tuned up since 2024. I reached out to David and he got me in quickly and worked on my bike within a day! He was super communicative and very patient with my schedule challenges (mom of a young kid!). I am super thrilled that he is a neighbor and is offering a much need service for the community!',
    author: 'S. T.',
  },
  {
    quote: "Great communicator, prompt, fair pricing, gives helpful recommendations, and does it all with a positive attitude! Also just a cool and knowledgeable person to chat with. À la carte bike services are such an awesome asset to the neighborhood, and we're thrilled we met Dave!",
    author: 'Yifan L.',
  },
  {
    quote: "I didn’t pay because David is a friend and I’m a mooch. But he fixed what my dumbass could not, and quickly.",
    author: 'Kyle M.'
  },
];

const logos = [logo, logoOs, logoFlock, logoBoh, logoUtz];

export default function Home() {
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [logoIndex, setLogoIndex] = useState(0);

  useEffect(() => {
    document.title = 'Bike Service';
  }, []);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveTestimonial((current) => (current + 1) % testimonials.length);
    }, 10000);

    return () => window.clearInterval(timer);
  }, []);

  // Cycle the header logo every 3 seconds
  useEffect(() => {
    const logoTimer = window.setInterval(() => {
      setLogoIndex((current) => (current + 1) % logos.length);
    }, 3000);

    return () => window.clearInterval(logoTimer);
  }, []);

  return (
    <div className="page-shell">
      <header className="page-header">
        <img src={logos[logoIndex]} alt="DAKLabb logo" className="site-logo" />
        {/*
          To enable cycling the logo on any page click, uncomment below:

          useEffect(() => {
            const handleCycle = () => setLogoIndex((c) => (c + 1) % logos.length);
            window.addEventListener('click', handleCycle);
            return () => window.removeEventListener('click', handleCycle);
          }, []);

        */}
        <div className="hero-copy">
          <p className="hero-badge">Local bike service in <b>your</b> neighborhood</p>
          <h1>Bike repair in the heart of the South Baltimore peninsula.</h1>
          <p>
            I’m a neighborhood bike mechanic working out of my home, offering repairs,
            advice, and dependable service at a reasonable price.
          </p>

          <p className="contact-cta">
            <b>Text me:</b> <a href="tel:6084325325">608-432-5325</a> <br />or<br />
            <b>Email</b> <a href="mailto:David@DAKLabb.com">David@DAKLabb.com</a><br /> Response usually within a few hours.
          </p>
        </div>
      </header>

      <main className="page-content">
        <section className="intro-card">
          <h2>Bike service that feels personal</h2>
          <p>
            I work with commuters, enthusiasts, families, and anyone who wants a reliable bike
            without the up-selling of a big shop. I’m based in the heart of the South Baltimore peninsula,
            and I offer mobile service within the neighborhood when it makes sense for the job.
          </p>
          <p>
            I can often get your bike back to you within <b>24 hours</b> (assuming parts are available). If your repair needs new parts, I'm happy to help you find them or install parts you've already purchased.
          </p>
        </section>

        <section className="section-grid">
          <article className="card">
            <h3>Services</h3>
            <ul className="service-list">
              <li>Flat fixes and tube/tire replacement</li>
              <li>Brake and shifting adjustments</li>
              <li>Tune-ups and safety checks</li>
              <li>Chain cleaning, lubrication, and drivetrain care</li>
              <li>Wheel trueing and minor wheel repairs</li>
            </ul>
          </article>

          <article className="card">
            <h3>What to expect</h3>
            <ul className="service-list">
              <li>Reasonable pricing and clear communication</li>
              <li>Fast turnaround when parts are available</li>
              <li>Mobile service available</li>
              <li>Support for self-sourcing parts</li>
            </ul>
          </article>
        </section>

        <section className="testimonial-section" aria-label="Testimonials">
          <h2>What neighbors say</h2>
          <div className="testimonial-card">
            <p>“{testimonials[activeTestimonial].quote}”</p>
            <p className="testimonial-author">— {testimonials[activeTestimonial].author}</p>
          </div>
          <div className="testimonial-controls">
            <button
              type="button"
              onClick={() => setActiveTestimonial((current) => (current - 1 + testimonials.length) % testimonials.length)}
              aria-label="Previous testimonial"
            >
              ←
            </button>
            <span>
              {activeTestimonial + 1} / {testimonials.length}
            </span>
            <button
              type="button"
              onClick={() => setActiveTestimonial((current) => (current + 1) % testimonials.length)}
              aria-label="Next testimonial"
            >
              →
            </button>
          </div>
        </section>

      </main>
    </div>
  );
}
